/**
 * Parses an object (like one used for $.ajax) into a html form and submits it. 
 */
(function($){

	$.formFromObject = function(data, action, method, target){
		var data = data ? data : {};
		var action = action ? action : '';
		var method = method ? method : 'POST';
		var target = target ? target : '';

		var form = $('<form></form>');
		form.attr('action', action)
			.attr('method', method)
			.css('style', 'display:none');


		if (target) {
			form.attr('target', target);
		}
		
		var paramSet = objectToParamSet(data);
		
		for(var k in paramSet){
			var v = paramSet[k];
			var input = $('<input type="hidden"></input>');
			input.attr('name', k)
				 .attr('value', v);
			form.append(input);
		}
		
		$('body').append(form);
		form.submit();
	};
	
	/**
	 * @param obj - an object
	 * @returns object - { key: <param key>, value: <param value> }
	 */
	var objectToParamSet = function(obj){
		return _objectToParamSet(obj, 0);
	};
	
	/**
	 * @param data - an object, array, number, string, or null
	 * @returns object - { key: <param key>, value: <param value> }
	 */
	var _objectToParamSet = function(data, depth){
		var r = {};
		for(var k in data){
			var v = data[k];
			
			if($.isArray(v) || (v instanceof Object)){
				var subData = _objectToParamSet(v, depth+1);
				for(var subK in subData){
					var subV = subData[subK];
					var _key = (depth == 0) ? k+subK : '['+k+']'+subK; 
					r[_key] = subV;
				}
			}else{
				var _key = (depth == 0) ? k : '['+k+']';
				r[_key] = v;
			}
		}
		return r;
	};
	
})(jQuery);
